// Auto-generated by scripts/scan-models.js
// DO NOT EDIT MANUALLY - Changes will be overwritten
// To add models: Add .glb files to public/models/ and restart npm run dev

export interface DiscoveredModel {
    id: string;
    name: string;
    glbPath: string;
}

/**
 * Returns list of available models
 * Auto-generated from public/models/*.glb files
 */
export function discoverModels(): DiscoveredModel[] {
    return getDefaultModels();
}

/**
 * Get current models list (auto-generated)
 */
export function getDefaultModels(): DiscoveredModel[] {
    return [
        {
                id: "cap",
                name: "Cap",
                glbPath: "/models/Cap.glb"
        },
        {
                id: "diary",
                name: "Diary",
                glbPath: "/models/Diary.glb"
        },
        {
                id: "dye-sublimated-lanyard-with-metal-crimp",
                name: "Dye Sublimated Lanyard with Metal Crimp",
                glbPath: "/models/Dye-Sublimated Lanyard with Metal Crimp.glb"
        },
        {
                id: "glass-award",
                name: "Glass Award",
                glbPath: "/models/Glass Award.glb"
        },
        {
                id: "jar",
                name: "Jar",
                glbPath: "/models/Jar.glb"
        },
        {
                id: "lip-balm",
                name: "Lip balm",
                glbPath: "/models/Lip balm.glb"
        },
        {
                id: "nylon-lanyard",
                name: "Nylon Lanyard",
                glbPath: "/models/Nylon Lanyard.glb"
        },
        {
                id: "pen",
                name: "Pen",
                glbPath: "/models/Pen.glb"
        },
        {
                id: "polo-tshirt",
                name: "Polo Tshirt",
                glbPath: "/models/Polo Tshirt.glb"
        },
        {
                id: "sports-jersey",
                name: "Sports Jersey",
                glbPath: "/models/Sports Jersey.glb"
        },
        {
                id: "square-pen",
                name: "Square Pen",
                glbPath: "/models/Square_Pen.glb"
        },
        {
                id: "towel",
                name: "Towel",
                glbPath: "/models/Towel.glb"
        },
        {
                id: "tumbler",
                name: "Tumbler",
                glbPath: "/models/Tumbler.glb"
        }
];
}
